import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { AuthShell } from "@/pages/Login";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Passwort zurückgesetzt. Bitte anmelden.");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Neues Passwort" subtitle="Legen Sie ein neues Passwort fest.">
      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label htmlFor="password">Neues Passwort</Label>
          <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="mt-1.5 h-11" data-testid="reset-password-input" placeholder="Mind. 6 Zeichen" />
        </div>
        {error && <p className="text-sm text-red-600" data-testid="reset-error">{error}</p>}
        <Button type="submit" className="w-full h-11" disabled={loading || !token} data-testid="reset-submit-btn">
          {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Passwort zurücksetzen"}
        </Button>
      </form>
      <p className="mt-6 text-center text-sm text-slate-500">
        <Link to="/login" className="text-primary font-semibold hover:underline">Zurück zur Anmeldung</Link>
      </p>
    </AuthShell>
  );
}
